module.exports = {
  src: __webpack_public_path__ + "static/media/commercial_00006.68be14ea.jpg",
  width: 3168,
  height: 4752,
  bytes: 738846,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/commercial_00006.68be14ea.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/commercial/commercial_00006.jpg
// module id = 241
// module chunks = 0